import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetState } from '../../../store/actions';
import { RootState } from '../../../store/store';

interface SignRequestState {
  activeSignRequestId: string | null;
  tempSignRequestId: string | null;
  isSignRequestPreviewOpen: boolean;
  selectedSignRequestIds: string[];
}

const initialState: SignRequestState = {
  activeSignRequestId: null,
  tempSignRequestId: null,
  isSignRequestPreviewOpen: false,
  selectedSignRequestIds: [],
};

const signRequestsSlice = createSlice({
  name: 'signRequests',
  initialState,
  reducers: {
    setActiveSignRequestId: (state, { payload }: PayloadAction<string | null>) => {
      state.activeSignRequestId = payload;
    },
    setTempSignRequestId: (state, { payload }: PayloadAction<string | null>) => {
      state.tempSignRequestId = payload;
    },
    setIsSignRequestPreviewOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isSignRequestPreviewOpen = payload;
    },
    setSelectedSignRequestIds: (state, { payload }: PayloadAction<string[]>) => {
      state.selectedSignRequestIds = payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(resetState.match, () => initialState);
  },
});

export const selectActiveSignRequestId = (state: RootState) => state.signRequests.activeSignRequestId;
export const selectTempSignRequestId = (state: RootState) => state.signRequests.tempSignRequestId;
export const selectIsSignRequestPreviewOpen = (state: RootState) => state.signRequests.isSignRequestPreviewOpen;
export const selectSelectedSignRequestIds = (state: RootState) => state.signRequests.selectedSignRequestIds;

export const { setActiveSignRequestId, setTempSignRequestId, setIsSignRequestPreviewOpen, setSelectedSignRequestIds } =
  signRequestsSlice.actions;

const signRequestsReducer = signRequestsSlice.reducer;

export default signRequestsReducer;
